"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Illustration = void 0;
var illustration_1 = require("./illustration");
Object.defineProperty(exports, "Illustration", { enumerable: true, get: function () { return illustration_1.Illustration; } });
//# sourceMappingURL=index.js.map